<template>
  <div id="q-app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  async created () {
    try {
      this.$q.loading.show()
    } catch {
      // fail silently
    } finally {
      this.$q.loading.hide()
    }
  }
}
</script>
